<div class="row">
    <div class="col-md-12">
    <h2>Important Announcement</h2>
    </div>
</div>
<app-home-card-config [contenttype]="'announcements'"></app-home-card-config>
